var scope_0 = require('/vercel/workpath0/projects/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0b2a9fff7703279bce9637447b4bdc26.js').default;
var scope_1 = require('/vercel/workpath0/projects/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0edabfab51dd0e051e6376182611f86f.js').default;
var scope_2 = require('/vercel/workpath0/projects/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_3 = require('/vercel/workpath0/projects/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/25e37a5df84721ad5631936f7ddf187b.js').default;
var scope_4 = require('/vercel/workpath0/projects/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3fee9d88925a36fa8b28f623b77cdaa2.js').default;
var scope_5 = require('/vercel/workpath0/projects/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5bfb24895857bd1a13338ce1c4728f3d.js').default;
var scope_6 = require('/vercel/workpath0/projects/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/650b5989143d5f31deb063bac46c5bf2.js').default;
var scope_7 = require('/vercel/workpath0/projects/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/78c7c1c31c419bdaea540a97aa57b2db.js').default;
var scope_8 = require('/vercel/workpath0/projects/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7c9c5a0a8e76a4018fa2ecb641ce5107.js').default;
var scope_9 = require('/vercel/workpath0/projects/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/82db5d3421cec6031d0d7f71c0144608.js').default;
var scope_10 = require('/vercel/workpath0/projects/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/95860d10a6c9de6a5ec56f8ac9c0b055.js').default;
var scope_11 = require('/vercel/workpath0/projects/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ad4924c8399603b4866397d2e559bc9b.js').default;
var scope_12 = require('/vercel/workpath0/projects/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d8e9d2c9c3c4c38bcc222c1b0d97734e.js').default;
var scope_13 = require('/vercel/workpath0/projects/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/da22153f67843788cf2c60781112296e.js').default;
var scope_14 = require('/vercel/workpath0/projects/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f06b455d032fab37051e7d5ee169ab65.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14 )
    